// Order of the currencies should never be modified, or modified with care,
// as other modules rely on the specific order in this array of currencies
export const allCurrencyCodes = [
  {
    name: 'Canadian Dollar (CAD)',
    symbol: '$',
    code: 'DEXCAUS',
  },
  {
    name: 'U.S. Dollar (USD)',
    symbol: '$',
    code: false, // No code; USD is base conversion currency where all other currencies have rates w.r.t USD
  },
  {
    name: 'Euro (EUR)',
    symbol: '€',
    code: 'DEXUSEU',
    reverse: true,
  },
  {
    name: 'Pound Sterling (GBP)',
    symbol: '£',
    code: 'DEXUSUK',
    reverse: true,
  },
  {
    name: 'Japanese Yen (JPY)',
    symbol: '¥',
    code: 'DEXJPUS',
  },
  {
    name: 'Chinese Yuan Renminbi (RMB)',
    symbol: '¥',
    code: 'DEXCHUS',
  },
  {
    name: 'Swiss Franc (CHF)',
    symbol: 'Fr.',
    code: 'DEXSZUS',
  },
  {
    name: 'Australian Dollar (AUD)',
    symbol: 'A$',
    code: 'DEXUSAL',
    reverse: true,
  },
  {
    name: 'New Zealand Dollar (NZD)',
    symbol: 'NZ$',
    code: 'DEXUSNZ',
    reverse: true,
  },
  {
    name: 'Singapore Dollar (SGD)',
    symbol: 'S$',
    code: 'DEXSIUS',
  },
  {
    name: 'South African Rand (ZAR)',
    symbol: 'R',
    code: 'DEXSFUS',
  },
  {
    name: 'Brazilian Real (BRL)',
    symbol: 'R$',
    code: 'DEXBZUS',
  },
  {
    name: 'Hong Kong Dollar (HKD)',
    symbol: 'HK$',
    code: 'DEXHKUS',
  },
  {
    name: 'New Taiwan Dollar (TWD)',
    symbol: 'NT$',
    code: 'DEXTAUS',
  },
  {
    name: 'New Israeli Sheqel (ILS)',
    symbol: '₪',
    code: 'CCUSMA02ILM618N',
  },
  {
    name: 'Indian Rupee (INR)',
    symbol: '₹',
    code: 'DEXINUS',
  },
  {
    name: 'Sri Lankan Rupee (LKR)',
    symbol: 'Rs.',
    code: 'DEXSLUS',
  },
  {
    name: 'Danish Kroner (DKK)',
    symbol: 'kr.',
    code: 'DEXDNUS',
  },
  {
    name: 'Norwegian Kroner (NOK)',
    symbol: 'kr.',
    code: 'DEXNOUS',
  },
  {
    name: 'Swedish Kroner (SEK)',
    symbol: 'kr.',
    code: 'DEXSDUS',
  },
  {
    name: 'Malaysian Ringgit (MYR)',
    symbol: 'RM',
    code: 'DEXMAUS',
  },
  {
    name: 'Thai Baht (THB)',
    symbol: '฿',
    code: 'DEXTHUS',
  },
  {
    name: 'South Korean Won (KRW)',
    symbol: '₩',
    code: 'DEXKOUS',
  },
  {
    name: 'Mexican Pesos (MXN)',
    symbol: 'M$',
    code: 'DEXMXUS',
  },
  {
    name: 'Indonesian Rupiah (IDR)',
    symbol: 'Rp',
    code: 'CCUSMA02IDM618N',
  },
];
